<template>
  <div class="aml-check">
    <div class="btn-display" v-if="!showForm" @click="runAMLCheck">
      <button :disabled="loading">
        {{ loading ? "Checking..." : "Run AML Check" }}
      </button>
    </div>

    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div v-if="showForm">
      <div class="tabs-header">
        <span
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: activeTab === index }"
          @click="selectTab(index)"
        >
          {{ tab }}
        </span>
      </div>

      <div class="tab-content">
        <div v-if="activeTab === 0">
          <h3 style="font-size: 24px; font-weight: 700">
            Identification Information
          </h3>

          <div>
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="link"
                  label="Image Link"
                  placeholder="Image Link"
                  class="m-1"
                  v-model="
                    agentDetails.name.pep[0].identification_information.image
                  "
                  :disabled="true"
                ></fg-input>
                <a
                  v-if="
                    agentDetails.name.pep[0].identification_information.image
                  "
                  :href="
                    agentDetails.name.pep[0].identification_information.image
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                  >View Link</a
                >
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Full Name"
                  placeholder="Full Name"
                  v-model="
                    agentDetails.name.pep[0].identification_information
                      .full_name
                  "
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Date of Birth"
                  placeholder="Date of Birth"
                  v-model="
                    agentDetails.name.pep[0].identification_information
                      .date_of_birth
                  "
                  :disabled="true"
                ></fg-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Nationality"
                  placeholder="Nationality"
                  v-model="
                    agentDetails.name.sanction[0].other_information.nationality
                  "
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Gender"
                  placeholder="Gender"
                  v-model="
                    agentDetails.name.sanction[0].personal_details.gender
                  "
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Citizenship"
                  placeholder="Citizenship"
                  :disabled="true"
                ></fg-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Aliases"
                  placeholder="Aliases"
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Place of Birth"
                  placeholder="Place of Birth"
                  :disabled="true"
                ></fg-input>
              </div>
            </div>
          </div>

          <h3 style="font-size: 24px; font-weight: 700">Family Connections</h3>
          <div>
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Spouse Name"
                  placeholder="Spouse Name"
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Children"
                  placeholder="Children"
                  v-model="
                    agentDetails.name.pep[0].family_connections[0]
                      .children_count
                  "
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Siblings"
                  placeholder="Siblings"
                  :disabled="true"
                ></fg-input>
              </div>
            </div>
          </div>

          <h3 style="font-size: 24px; font-weight: 700">Occupations</h3>
          <div>
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Occupation"
                  placeholder="Occupation"
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Political Party"
                  placeholder="Political Party"
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Position and Function"
                  placeholder="Position and Function"
                  v-model="agentDetails.name.pep[0].position_and_function"
                  :disabled="true"
                ></fg-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="link"
                  label="Data Source"
                  placeholder="Data Source"
                  class="m-1"
                  v-model="agentDetails.name.pep[0].data_source"
                  :disabled="true"
                ></fg-input>
                <a
                  v-if="agentDetails.name.pep[0].data_source"
                  :href="agentDetails.name.pep[0].data_source"
                  target="_blank"
                  rel="noopener noreferrer"
                  >View Link</a
                >
              </div>
            </div>
          </div>

          <h3 style="font-size: 24px; font-weight: 700">
            Percentage Name Match
          </h3>
          <div>
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Percentage"
                  placeholder="Percentage"
                  v-model="
                    agentDetails.name.pep[0].identification_information
                      .percentage_name_match
                  "
                  :disabled="true"
                ></fg-input>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 1">
          <h3 style="font-size: 24px; font-weight: 700">Personal Details</h3>
          <div>
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Full Name"
                  placeholder="Full Name"
                  v-model="agentDetails.name.sanction[0].personal_details.name"
                  :disabled="true"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Image Link"
                  placeholder="Image Link"
                  class="m-1"
                  v-model="agentDetails.name.sanction[0].personal_details.image"
                  :disabled="true"
                ></fg-input>
                <a
                  v-if="agentDetails.name.sanction[0].personal_details.image"
                  :href="agentDetails.name.sanction[0].personal_details.image"
                  target="_blank"
                  rel="noopener noreferrer"
                  >View Link</a
                >
              </div>

              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Aliases"
                  placeholder="Aliases"
                  :disabled="true"
                ></fg-input>
              </div>
            </div>

            <h3 style="font-size: 24px; font-weight: 700">Other Information</h3>
            <div>
              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Date of Birth"
                    placeholder="Date of Birth"
                    v-model="
                      agentDetails.name.pep[0].identification_information
                        .date_of_birth
                    "
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Gender"
                    placeholder="Gender"
                    v-model="
                      agentDetails.name.sanction[0].personal_details.gender
                    "
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Eyes"
                    placeholder="Eyes"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Hair"
                    placeholder="Hair"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Height"
                    placeholder="Height"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Reward"
                    placeholder="Reward"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Weight"
                    placeholder="Weight"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Aliases"
                    placeholder="Aliases"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Caution"
                    placeholder="Caution"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Wanted In"
                    placeholder="Wanted In"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Scar Tattoo"
                    placeholder="Scar Tattoo"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Wanted for"
                    placeholder="Wanted for"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Race Ethnic"
                    placeholder="Race Ethnic"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Wanted Since"
                    placeholder="Wanted Since"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>
            </div>

            <h3 style="font-size: 24px; font-weight: 700">Summary</h3>
            <div>
              <div class="col p-0">
                <div class="">
                  <textarea
                    label="Summary"
                    placeholder="Summary"
                    cols="5"
                    rows="5"
                    v-model="agentDetails.name.sanction[0].summary"
                    :disabled="true"
                  ></textarea>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Reference Link"
                    placeholder="Reference Link"
                    v-model="agentDetails.name.sanction[0].reference[0]"
                    :disabled="true"
                    class="m-1"
                  ></fg-input>
                  <a
                    v-if="agentDetails.name.sanction[0].reference[0]"
                    :href="agentDetails.name.sanction[0].reference[0]"
                    target="_blank"
                    rel="noopener noreferrer"
                    >View Link</a
                  >
                </div>
              </div>
            </div>

            <h3 style="font-size: 24px; font-weight: 700">
              Percentage Name Match
            </h3>

            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Percentage"
                  placeholder="Percentage"
                  v-model="agentDetails.name.sanction[0].percentage_name_match"
                  :disabled="true"
                ></fg-input>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 2">
          <h3 style="font-size: 24px; font-weight: 700">Risk Score</h3>
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Final Risk Score"
              placeholder="Final Risk Score"
              v-model="agentDetails.screening_result.final_risk_score"
              :disabled="true"
            ></fg-input>
          </div>

          <h3 style="font-size: 24px; font-weight: 700">Risk Rank</h3>
          <div class="col-md-4">
            <fg-input
              type="text"
              label=""
              placeholder="Final Risk Score"
              v-model="agentDetails.screening_result.risk_rank"
              :disabled="true"
            ></fg-input>
          </div>

          <h3 style="font-size: 24px; font-weight: 700">Rank Description</h3>
          <div class="">
            <textarea
              cols="5"
              rows="4"
              v-model="agentDetails.screening_result.rank_description"
              :disabled="true"
            ></textarea>
          </div>

          <div class="btn-display">
            <button @click="rerunAMLCheck">ReRun</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import Swal from "sweetalert2";

export default {
  props: {
    agentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 0,
      tabs: ["PEP Report", "Sanction Report", "Risk Report"],
      showTabs: false,
      showForm: false,
      loading: false,
      errorMsg: null,
      error: false,
      agentDetails: {},
    };
  },

  methods: {
    selectTab(index) {
      this.activeTab = index;
    },

    async runAMLCheck() {
      this.loading = true;
      this.error = false;
      this.errorMsg = null;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/aml/check/${this.$route.params.agentId}`,
        );
        // const response = await axios.get(
        //   `${process.env.VUE_APP_API_URL}/aml/check/674493c319b57c69b50be131`
        // );
        this.agentDetails = response.data.data;

        if (response.data.status === "success") {
          this.showForm = true;
          this.loading = false;
        } else {
          this.error = true;
          Swal.fire({
            icon: "error",
            title: "Error",
            html: `${response.data.message}`,
          });
          this.loading = false;
          this.errorMsg = response.data.message;
        }
      } catch (error) {
        this.error = true;
        this.errorMsg =
          error.response && error.response.data
            ? error.response.data.message
            : "An unknown error occurred.";
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },

    async checkData() {
      this.loading = true;
      this.error = false;
      this.errorMsg = null;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/agent/${this.$route.params.agentId}`,
        );

        const res = response.data.agent.data;

        if (res && res.name) {
          this.agentDetails = res;
          this.showForm = true;
          this.error = false;
        } else {
          this.showForm = false;
        }
      } catch (error) {
        this.error = true;
        this.errorMsg =
          error.response && error.response.data
            ? error.response.data.message
            : "An unknown error occurred.";
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },

    rerunAMLCheck() {
      this.runAMLCheck();
      this.showForm = false;
      this.activeTab = 0;
    },
  },

  mounted() {
    this.checkData();
  },
};
</script>

<style scoped>
.btn-display {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 0;
}
.btn-display button {
  border: none;
  outline: none;
  background: #65b3c7;
  color: white;
  font-size: 16px;
  padding: 12px 40px;
  border-radius: 4px;
}
.tabs-header {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid #9a9a9a;
  color: #9a9a9a;
  margin-bottom: 30px;
}
.tabs-header span {
  cursor: pointer;
}
span.active {
  padding: 8px 20px;
  color: #1eb75b;
  border-bottom: 1px solid #1eb75b;
  font-weight: 600;
}
textarea {
  background-color: #e3e3e3;
  cursor: not-allowed;
  color: #9a9a9a;
  opacity: 1;
  width: 100%;
  border: none;
  border-radius: 4px;
}
</style>
